import Vue from 'vue';
import { AvaliacaoPlugin } from 'px-business-components';

Vue.use(AvaliacaoPlugin, {});
